import "./SatelliteImageAcquisition.module.css";
import Header from "@/reusable_sections/Header";
import HeroSectionSatelliteImageAcquisition from "./sections/HeroSectionSatelliteImageAcquisition";
import ArmsatImageryShowcase from "./sections/ArmsatImageryShowcase";
import PilaresDeCrescimento from "./sections/PilaresDeCrescimento";
import PilaresAcademicos from "./sections/PilaresAcademicos";
import InquiryCallToAction from "./sections/InquiryCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SatelliteImageAcquisitionPage() {
  return <div>
      <Header />
      <HeroSectionSatelliteImageAcquisition />
      <ArmsatImageryShowcase />
      <PilaresAcademicos />
      <InquiryCallToAction />
      <Footer />
    </div>;
}